export default "/images/368570e17aec2acb18af5bcf6c42a5af.avif";